export enum InventoryStockAlert {
    NONE = 'none',
    LOW_STOCK = 'low_stock',
    OUT_OF_STOCK = 'out_of_stock',

    // Other alerts that we can support in the future
    // OVERSTOCK = 'overstock'
}